<template lang="html">
  <div class="capsule-status pt-1">
    <b-badge
      pill
      class="pr-3 pl-3"
      :variant="getVariant(stateName)"
      v-html="stateName"
    />
  </div>
</template>

<script>
import CapsuleUtils from "@/utils/CapsuleUtils";

export default {
  created() {
    this.getStateName = CapsuleUtils.getStateName;
    this.getVariant = CapsuleUtils.getVariant;
  },

  props: {
    status: {
      type: String
    },

    publishable: {
      type: Boolean
    },

    publishedOn: {
      type: String
    }
  },

  computed: {
    stateName() {
      return this.getStateName(this.status, this.publishable);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.capsule-status {
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// src/components/tailor/CapsuleStatus.vue